/**
 * Split trailing "Sources:" footnote from the main body of a Bizy message.
 *
 * Looks for the last markdown hr (`---`, `***`, `___`) followed by text containing "Sources".
 * Used by the markdown node to render the sources block in its own muted footer.
 */
export function splitSources(content: string): { body: string; sources: string | null } {
	const match = content.match(/^([\s\S]*)\n\s*(?:---|\*\*\*|___)\s*\n([\s\S]*sources[\s\S]*)$/i);
	if (match) {
		return { body: match[1].trimEnd(), sources: match[2].trimStart() };
	}
	return { body: content, sources: null };
}
